// test2669
(2669 && 0);
